import { Grid } from "@mui/material";
import WifiTetheringErrorOutlinedIcon from "@mui/icons-material/WifiTetheringErrorOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import LinkOffOutlinedIcon from "@mui/icons-material/LinkOffOutlined";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import { EventDto } from "../../interfaces/IEvent";
import { EventType } from "../../interfaces/IEventEnums";
import SelectableCard from "../../components/Card/SelectableCard";

interface EventTypeSelectionCardsProps {
    newEvent: EventDto;
    handleEventTypeChange: (name: string, eventType: EventType | null) => void;
}

function EventTypeSelectionCards({ newEvent, handleEventTypeChange }: EventTypeSelectionCardsProps) {
    const handleEventTypeLabelSelection = (eventType: EventType) => {
        const labels: any = {
            "Nettverk": "Nettverk",
            "Generell": "Generell",
            "Fellesfeil": "Fellesfeil",
            "Planlagt": "Planlagt",
        };

        return labels[eventType];
    };

    const handleEventTypeIconSelection = (eventType: EventType) => {
        const iconSettings = {
            sx: {
                fontSize: "1.5rem",
                opacity: "70%",
            },
        };

        const types: any = {
            "Nettverk": <WifiTetheringErrorOutlinedIcon sx={iconSettings} />,
            "Generell": <NoteAltOutlinedIcon sx={iconSettings} />,
            "Fellesfeil": <LinkOffOutlinedIcon sx={iconSettings} />,
            "Planlagt": <AssignmentTurnedInOutlinedIcon sx={iconSettings} />,
        };

        return types[eventType];
    };

    return (
        <>
            {Object.values(EventType).map(
                (eventType, index) => (
                    <Grid
                        key={index}
                        size={{
                            xs: 12,
                            md: 4
                        }}>
                        <SelectableCard
                            icon={handleEventTypeIconSelection(eventType)}
                            label={handleEventTypeLabelSelection(eventType)}
                            selected={newEvent.type === eventType}
                            onClick={() => { 
                                handleEventTypeChange("type", eventType)
                            }}
                        />
                    </Grid>
                )
            )}
        </>
    );
};

export default EventTypeSelectionCards;